import { createFileRoute } from "@tanstack/react-router";

import { GetStartedPage } from "@/features/get-started";

export const Route = createFileRoute("/_site/get-started")({
  head: () => ({ meta: [{ title: "Get Started · Softmax" }] }),
  component: GetStartedPage,
});
